import PageLoader from "./PageLoader";
import PageContentLoader from "./PageContentLoader";

const Loader = ({ isLoading, fullPage = false, children,bgColor }) => {
    return (
        <>
            {isLoading ? (fullPage ? <PageLoader /> : <PageContentLoader bgColor={bgColor} />) : null}
            <div style={isLoading ? { display: "none" } : {}}>{children}</div>
        </>
    );
};

export default Loader;
